import { red, navy, grey } from '../colors/care-colors.js';
/* @TODO this functionality will be available after v5.0.0-alpha.6 is stable
   @see https://github.com/mui-org/material-ui/pull/22006
   @see https://next.material-ui.com/customization/components/#adding-new-component-variants
   #TypographyFix
  export const MuiTypography = [
    {
      props: { variant: 'display1' },
      styles: {
        fontWeight: 700,
        fontSize: '3.5rem',
        lineHeight: '64px',
        marginTop: 64,
        marginBottom: 32,
      },
    },
    {
      props: { variant: 'display2' },
      styles: {
        fontWeight: 700,
        fontSize: '3rem',
        lineHeight: '56px',
        marginTop: 56,
        marginBottom: 28,
      },
    },
    {
      props: { variant: 'display3' },
      styles: {
        fontWeight: 700,
        fontSize: '2.25rem',
        lineHeight: '42px',
        marginTop: 42,
        marginBottom: 21,
      },
    },
    {
      props: { variant: 'body3' },
      styles: {
        fontWeight: 400,
        fontSize: '0.875rem',
        lineHeight: '20px',
      },
    },
    {
      props: { variant: 'info1' },
      styles: {
        fontWeight: 400,
        fontSize: '0.75rem',
        lineHeight: '16px',
      },
    },
    {
      props: { variant: 'info2' },
      styles: {
        fontWeight: 400,
        fontSize: '0.625rem',
        lineHeight: '14px',
      },
    },
    {
      props: { variant: 'disclaimer' },
      styles: {
        fontWeight: 400,
        fontSize: '0.625rem',
        lineHeight: '14px',
      },
    },
    {
      props: { variant: 'badge' },
      styles: {
        fontWeight: 400,
        fontSize: '0.75rem',
        lineHeight: '16px',
      },
    },
    {
      props: { variant: 'tag' },
      styles: {
        fontWeight: 700,
        fontSize: '0.75rem',
        lineHeight: '16px',
        textTransform: 'uppercase',
      },
    },
  ];
*/
const serifDefaults = {
    fontFamily: 'Lora, serif',
    fontWeight: 400,
};
const typography = {
    fontFamily: '"Proxima Nova", Arial, sans-serif',
    fontSize: 14,
    fontWeight: 400,
    h1: {
        fontWeight: 700,
        fontSize: '1.75rem',
        lineHeight: '34px',
    },
    h2: {
        fontWeight: 700,
        fontSize: '1.3125rem',
        lineHeight: '26px',
    },
    h3: {
        fontWeight: 700,
        fontSize: '1.125em',
        lineHeight: '24px',
    },
    h4: {
        fontWeight: 700,
        fontSize: '1rem',
        lineHeight: '22px',
    },
    h5: {
        fontWeight: 700,
        fontSize: '0.875rem',
        lineHeight: '18px',
    },
    body1: {
        fontWeight: 400,
        fontSize: '1.125rem',
        lineHeight: '24px',
    },
    body2: {
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: '24px',
    },
    body3: {
        fontWeight: 400,
        fontSize: '0.875rem',
        lineHeight: '20px',
    },
    badge: {
        fontWeight: 400,
        fontSize: '0.75rem',
        lineHeight: '16px',
    },
    disclaimer1: {
        fontWeight: 400,
        fontSize: '0.875rem',
        lineHeight: '20px',
    },
    disclaimer2: {
        fontWeight: 400,
        fontSize: '0.75rem',
        lineHeight: '16px',
    },
    display1: {
        fontWeight: 700,
        fontSize: '3.5rem',
        lineHeight: '64px',
    },
    display2: {
        fontWeight: 700,
        fontSize: '3rem',
        lineHeight: '56px',
    },
    display3: {
        fontWeight: 700,
        fontSize: '2.25rem',
        lineHeight: '42px',
    },
    info1: {
        fontWeight: 400,
        fontSize: '0.75rem',
        lineHeight: '16px',
    },
    info2: {
        fontWeight: 400,
        fontSize: '0.625rem',
        lineHeight: '14px',
    },
    link1: {
        fontSize: '18px',
        lineHeight: '24px',
    },
    link2: {
        fontSize: '16px',
        lineHeight: '24px',
    },
    link3: {
        fontSize: '14px',
        lineHeight: '20px',
    },
    link4: {
        fontSize: '12px',
        lineHeight: '16px',
    },
    serifDisplay1: Object.assign(Object.assign({}, serifDefaults), { fontSize: '3.5rem', lineHeight: '64px' }),
    serifDisplay2: Object.assign(Object.assign({}, serifDefaults), { fontSize: '3rem', lineHeight: '56px' }),
    serifDisplay3: Object.assign(Object.assign({}, serifDefaults), { fontSize: '2.25rem', lineHeight: '42px' }),
    serifHeadline1: Object.assign(Object.assign({}, serifDefaults), { fontSize: '2rem', lineHeight: '38px' }),
    serifHeadline2: Object.assign(Object.assign({}, serifDefaults), { fontSize: '1.75rem', lineHeight: '34px' }),
    serifHeadline3: Object.assign(Object.assign({}, serifDefaults), { fontSize: '1.5rem', lineHeight: '30px' }),
    serifHeadline4: Object.assign(Object.assign({}, serifDefaults), { fontSize: '1.3125rem', lineHeight: '26px' }),
    serifHeadline5: Object.assign(Object.assign({}, serifDefaults), { fontSize: '1.125rem', lineHeight: '24px' }),
    tag: {
        fontWeight: 700,
        fontSize: '0.75rem',
        lineHeight: '16px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    colorInherit: {
        color: navy[900],
    },
    colorPrimary: {
        color: navy[900],
    },
    colorSecondary: {
        color: grey[700],
    },
    colorTextPrimary: {
        color: navy[900],
    },
    colorTextSecondary: {
        color: grey[700],
    },
    colorError: {
        color: red[800],
    },
};
export default typography;
//# sourceMappingURL=data:application/json;base64,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